import './jalalidatepicker.min.js';
import { Tabs, Tooltip } from 'flowbite';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import '@dotlottie/player-component';

import.meta.glob(['../images/**']);

function getParentLang(node) {
  var defaultLang = 'fa';
  var currLang = null;
  while (currLang === null && node.parentNode) {
    if (node.getAttribute && node.getAttribute('lang')) {
      currLang = node.getAttribute('lang');
    }
    node = node.parentNode;
  }
  return currLang || defaultLang;
}

String.prototype.toPersianDigit = function (e) {
  return this.replace(/\d+/g, function (t) {
    var n = [],
      r = [];
    for (var i = 0; i < t.length; i++) {
      n.push(t.charCodeAt(i));
    }
    for (var s = 0; s < n.length; s++) {
      r.push(String.fromCharCode(n[s] + (!!e && e == true ? 1584 : 1728)));
    }
    return r.join('');
  });
};

jalaliDatepicker.startWatch({ maxDate: 'today' });

window.showLoading = function () {
  document.getElementById('loading-overlay').classList.add('flex-center');
};

window.hideLoading = function () {
  document.getElementById('loading-overlay').classList.remove('flex-center');
};

Livewire.hook('commit', ({ component, commit, respond, succeed, fail }) => {
  if (
    commit.calls &&
    commit.calls[0] &&
    'params' in commit.calls[0] &&
    commit.calls[0].params[0] === 'openModal'
  ) {
    showLoading();
  }

  // Hide loading spinner on close modal
  if (
    commit.calls &&
    commit.calls[0] &&
    commit.calls[0].method === 'resetState'
  ) {
    hideLoading();
    document.getElementById('modal-container').classList.remove('my-auto!');
  }
});

document.addEventListener('livewire:initialized', () => {
  // Hide loading spinner after modal loaded
  Livewire.hook('component.init', ({ component }) => {
    if (component.name.includes('modal')) {
      hideLoading();
    }

    if (component.name === 'consultation-request-modal') {
      let consultationTabElements = [];
      for (let i = 1; i <= 5; i++) {
        let triggerEl = document.querySelector('#date-' + i + '-tab-btn');
        let targetEl = document.querySelector('#date-' + i + '-tab-content');
        if (triggerEl && targetEl) {
          consultationTabElements.push({
            id: 'date-' + i,
            triggerEl: triggerEl,
            targetEl: targetEl,
          });
        }
      }

      new Tabs(
        document.getElementById('consultation-request-tabs'),
        consultationTabElements,
      );
    } else if (component.name === 'consultation-request-success-modal') {
      setTimeout(function () {
        Livewire.dispatch('closeModal', {
          component: 'consultation-request-success-modal',
        });
      }, '30000');
    } else if (
      component.name === 'referral-code-modal' ||
      component.name === 'dashboard.affiliation.share-modal'
    ) {
      const targetEl = document.getElementById('copy-tooltip');

      const triggerEl = document.getElementById('code-button');

      if (targetEl && triggerEl) {
        const options = {
          placement: 'bottom',
          triggerType: 'none',
        };

        const copyTooltip = new Tooltip(targetEl, triggerEl, options);

        window.copyCode = async function (code) {
          navigator.permissions
            .query({ name: 'clipboard-write' })
            .then(async (result) => {
              if (result.state == 'granted' || result.state == 'prompt') {
                try {
                  await navigator.clipboard.writeText(code);
                  copyTooltip.show();
                } catch (err) {}
              }
            });
        };
      }
    }
  });

  Livewire.hook('morph.updated', ({ el, component }) => {
    if (component.name === 'consultation-request-modal') {
      const consultationRequestTabs = document.getElementById(
        'consultation-request-tabs',
      );
      if (!consultationRequestTabs) {
        return;
      }
      const consultationTabElements = [
        {
          id: 'date-1',
          triggerEl: document.querySelector('#date-1-tab-btn'),
          targetEl: document.querySelector('#date-1-tab-content'),
        },
        {
          id: 'date-2',
          triggerEl: document.querySelector('#date-2-tab-btn'),
          targetEl: document.querySelector('#date-2-tab-content'),
        },
        {
          id: 'date-3',
          triggerEl: document.querySelector('#date-3-tab-btn'),
          targetEl: document.querySelector('#date-3-tab-content'),
        },
        {
          id: 'date-4',
          triggerEl: document.querySelector('#date-4-tab-btn'),
          targetEl: document.querySelector('#date-4-tab-content'),
        },
      ];

      new Tabs(consultationRequestTabs, consultationTabElements);
    } else if (component.name.startsWith('micro-learning.')) {
      if ('MathJax' in window) {
        MathJax.typeset();
      }
    }
  });
});

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

window.setCookie = setCookie;

function getCookie(cname) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
window.getCookie = getCookie;

document.addEventListener('livewire:initialized', () => {
  // Hide loading spinner after modal loaded
  Livewire.hook('component.init', ({ component }) => {
    if (component.name === 'summer-campaign.prize-modal') {
      hideLoading();
      // copy referral code
      const targetEl = document.getElementById('copy-tooltip');

      const triggerEl = document.getElementById('code-button');

      if (targetEl && triggerEl) {
        const options = {
          placement: 'bottom',
          triggerType: 'none',
          onHide: () => {},
          onShow: () => {},
          onToggle: () => {},
        };

        const copyTooltip = new Tooltip(targetEl, triggerEl, options);

        window.copyCode = async function (code) {
          navigator.permissions
            .query({ name: 'clipboard-write' })
            .then(async (result) => {
              if (result.state == 'granted' || result.state == 'prompt') {
                try {
                  await navigator.clipboard.writeText(code);
                  copyTooltip.show();
                } catch (err) {}
              }
            });
        };
      }
    } else if (component.name.startsWith('yalda-campaign.')) {
      document
        .getElementById('modal-container')
        .classList.remove(
          'rounded-radius-xl',
          'rounded-b-none',
          'sm:rounded-radius-xl',
          'border',
          'border-secondary-300',
        );

      const modalHeader = document.getElementById(
        'yalda-campaign-modal-header',
      );
      if (modalHeader) {
        const headerTexts = ['الان بازی&nbsp;کـن', 'فرصت کمــه'];
        const headerColors = ['#fda344', '#e8590f'];
        let headerStateIdx = 0;

        setInterval(function () {
          headerStateIdx = 1 - headerStateIdx;
          modalHeader.innerHTML = headerTexts[headerStateIdx];
          modalHeader.style.backgroundColor = headerColors[headerStateIdx];
        }, 600);

        const modalSubtitle = document.getElementById(
          'yalda-campaign-modal-subtitle',
        );
        const headerSubtitleTexts = [
          'ناردونــه‌هــا رو جمــع&nbsp;کــن',
          'و جایــــزه بگیـــر',
        ];
        const headerSubtitleFontWeights = ['700', '900'];
        const headerSubtitleFontSizes = ['1.5rem', '2.25rem'];
        let headerSubtitleStateIdx = 0;

        setInterval(function () {
          headerSubtitleStateIdx = 1 - headerSubtitleStateIdx;
          modalSubtitle.innerHTML = headerSubtitleTexts[headerSubtitleStateIdx];
          modalSubtitle.style.fontWeight =
            headerSubtitleFontWeights[headerSubtitleStateIdx];
          modalSubtitle.style.fontSize =
            headerSubtitleFontSizes[headerSubtitleStateIdx];
        }, 600);
      }
      if (component.name === 'yalda-campaign.game-over-modal') {
        window.wrongAnswer = function (idx) {
          const choice = document.getElementById(
            'game-over-modal-choice-' + idx,
          );
          const choiceText = document.getElementById(
            'game-over-modal-choice-text-' + idx,
          );
          const correctAnswer = document.getElementById(
            'game-over-modal-correct-answer',
          );
          const modal = document.getElementById('game-over-modal-content');
          const questionContent = document.getElementById(
            'game-over-modal-question-content',
          );
          const finalContent = document.getElementById(
            'game-over-modal-final-content',
          );
          choice.classList.add('bg-[#D92D20]!', 'hover:bg-[#D92D20]!');
          choiceText.classList.add('text-white!');
          correctAnswer.classList.add('border-4', 'border-primary-800');
          game.AudioPlayer.play('Mario Dies');
          setTimeout(() => {
            questionContent.classList.add('hidden');
            finalContent.classList.remove('hidden');
          }, 3000);
        };
      }
    }
  });
});

for (const placement of ['top', 'left', 'right', 'bottom']) {
  for (const tooltipButton of document.querySelectorAll(
    `.x-tooltip-button.track-roadmap-item:has(.x-tooltip-${placement})`,
  )) {
    const tooltip = tooltipButton.querySelector(`.x-tooltip-${placement}`);
    tippy(tooltipButton, {
      theme: 'rounded',
      trigger: 'click',
      interactive: true,
      content: tooltip.innerHTML,
      allowHTML: true,
      placement: placement,
    });
    tooltip.remove();
  }
}

for (const placement of ['top', 'left', 'right', 'bottom']) {
  for (const tooltipButton of document.querySelectorAll(
    `.x-tooltip-button:not(.track-roadmap-item):has(.x-tooltip-${placement})`,
  )) {
    const tooltip = tooltipButton.querySelector(`.x-tooltip-${placement}`);
    tippy(tooltipButton, {
      theme: 'light',
      content: tooltip.innerHTML,
      allowHTML: true,
      placement: placement,
    });
    tooltip.remove();
  }
}

for (const placement of ['top', 'left', 'right', 'bottom']) {
  for (const tooltipButton of document.querySelectorAll(
    `.x-tooltip-button-dark:has(.x-tooltip-${placement})`,
  )) {
    const tooltip = tooltipButton.querySelector(`.x-tooltip-${placement}`);
    tippy(tooltipButton, {
      theme: 'dark',
      content: tooltip.innerHTML,
      allowHTML: true,
      placement: placement,
    });
    tooltip.remove();
  }
}
